import type { ScenarioPreview } from "../types/scenario";

/**
 * Generate a smart auto-suggested scenario name based on preview metrics.
 * Returns a unique name that doesn't conflict with existing scenario names.
 *
 * Naming rules:
 * - First save (no existing): "Baseline Plan"
 * - Retirement age ≤ 60: "Early Retirement"
 * - Retirement age ≥ 68: "Extended Career"
 * - Otherwise: "Retire at {age}"
 * - If name conflicts, appends incrementing number ("Plan 2", "Plan 3", etc.)
 */
export const suggestScenarioName = (
  preview: ScenarioPreview,
  existingNames: string[]
): string => {
  let baseName: string;

  if (existingNames.length === 0) {
    baseName = "Baseline Plan";
  } else if (preview.retirementAge <= 60) {
    baseName = "Early Retirement";
  } else if (preview.retirementAge >= 68) {
    baseName = "Extended Career";
  } else {
    baseName = `Retire at ${Math.round(preview.retirementAge)}`;
  }

  if (!existingNames.includes(baseName)) return baseName;

  for (let i = 2; i <= 20; i++) {
    const candidate = `${baseName} ${i}`;
    if (!existingNames.includes(candidate)) return candidate;
  }

  return baseName;
};
